export default __webpack_public_path__ + "img/inspection.fcaf5b73.png";